export default __webpack_public_path__ + "static/media/geometry-artwork-1.e7d32f95.jpg";